import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {Logger, LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {PearlHarborGameAssets} from "./PearlHarborGameAssets";
import {PearlHarborBackground} from "./view/PearlHarborBackground";
import {PearlHarborWinPresentation} from "./gameflow/avalanche/PearlHarborWinPresentation";
import {PearlHarborNormalBetPresentation} from "./gameflow/PearlHarborNormalBetPresentation";
import {PearlHarborNormalResultPresentation} from "./gameflow/PearlHarborNormalResultPresentation";
import {PearlHarborIdleNormalPresentation} from "./gameflow/PearlHarborIdleNormalPresentation";
import {PearlHarborZeroBetIdlePresentation} from "./gameflow/freespin/PearlHarborZeroBetIdlePresentation";
import {PearlHarborModel} from "./server/PearlHarborModel";
import {PearlHarborReelAreaView} from "./reels/PearlHarborReelAreaView";
import {PearlHarborForeground} from "./view/PearlHarborForeground";
import {PearlHarborGameMode} from "./server/PearlHarborGameMode";
import {PearlHarborIdlePresentation} from "./gameflow/avalanche/PearlHarborIdlePresentation";
import {PearlHarborBetPresentation} from "./gameflow/avalanche/PearlHarborBetPresentation";
import {PearlHarborFillUpReelsPresentation} from "./gameflow/avalanche/PearlHarborFillUpReelsPresentation";
import {PearlHarborGameConfig} from "./PearlHarborGameConfig";
import {Multiplier} from "./view/Multiplier";
import {PearlHarborTotalWinView} from "./view/PearlHarborTotalWinView";
import {ScatterAnimation} from "./view/ScatterAnimation";
import {PearlHarborWinCapView} from "./view/PearlHarborWinCapView";
import {PearlHarborFSOutro} from "./view/freespin/PearlHarborFSOutro";
import {PearlHarborBigWin} from "./view/PearlHarborBigWin";
import {PearlHarborFSBetPresentation} from "./gameflow/freespin/PearlHarborFSBetPresentation";
import {PearlHarborMainGameView} from "./view/PearlHarborMainGameView";
import {PearlHarborFSIntro} from "./view/PearlHarborFSIntro";
import {PearlHarborSoundManager} from "./sound/PearlHarborSoundManager";
import {PearlHarborInitialWinView} from "./view/PearlHarborInitialWinView";
import {PearlHarborHelper} from "./utils/PearlHarborHelper";
import {PearlHarborLuckyDrawAnimation} from "./view/PearlHarborLuckyDrawAnimation";
import {ActiveSymbolBackground} from "./view/ActiveSymbolBackground";
import {CocpitBoard} from "./view/freespin/CocpitBoard";
import {PearlHarborFSResultPresentation} from "./gameflow/freespin/PearlHarborFSResultPresentation";
import {PearlHarborFSWinPresentation} from "./gameflow/freespin/PearlHarborFSWinPresentation";
import {DogfightWinPresentation} from "./view/freespin/DogfightWinPresentation";
import {BombAttackWinPresentation} from "./view/freespin/BombAttackWinPresentation";
import {ScatterCounter} from "./view/ScatterCounter";
import {PearlHarborToggleState} from "./components/gui/PearlHarborToggleStateSet";
import {ISymbolValues} from "./server/PearlHarborData";
import {TemplateAsset, TemplateLoader} from "@nolimitcity/slot-launcher/bin/loader/TemplateLoader";
import {Speedster} from "./debug/Speedster";
import {NolimitConfig} from "@nolimitcity/slot-launcher/bin/settings/NolimitConfig";
import {HitChanceBoard} from "./view/freespin/HitChanceBoard";
import {KamakaziWinPresentation} from "./view/freespin/KamakaziWinPresentation";
import {PromoPanelEvents} from "@nolimitcity/promo-panel/bin/events/PromoPanelEvents";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {Skinner} from "@nolimitcity/slot-launcher/bin/utils/Skinner";

export class PearlHarbor extends SlotGame {
    public static model: PearlHarborModel;
    public static assetLoader: AssetLoader;
    public static allReelsView: PearlHarborReelAreaView;
    public static backgroundElements: PearlHarborBackground;
    public static foregroundElements: PearlHarborForeground;
    public static gameFlowController: GameFlowController;
    public static multiplier: Multiplier;
    public static scatterCounter: ScatterCounter;
    public static totalWinView: PearlHarborTotalWinView;
    public static scatterAnimation: ScatterAnimation;
    public static winCapView: PearlHarborWinCapView;
    public static fsIntroView: PearlHarborFSIntro;
    public static fsOutroView: PearlHarborFSOutro;
    public static totalBigWinView: PearlHarborBigWin;
    public static mainGameZoomContainer: PearlHarborMainGameView;
    public static activeSymbolsBackground: ActiveSymbolBackground;
    //public static speedster: Speedster;
    public static initialWinView: PearlHarborInitialWinView;
    public static luckyDrawFeatureBuy: PearlHarborLuckyDrawAnimation;
    public static cocpitBoard: CocpitBoard;
    public static dogfightWin: DogfightWinPresentation;
    public static bombAttackWin: BombAttackWinPresentation;
    public static hitChanceBoard: HitChanceBoard;
    public static kamakazi: KamakaziWinPresentation;

    public static enteringInFs: boolean = false;
    public static bigWinPlayed: boolean = false;
    public static DELAY_BEFORE_OUTRO: number = 2;
    public static canAddPauseInFS: boolean = true;
    // #350
    public static abortInFS: boolean = false;
    public static promoPanelOpened: boolean = false;
    private _defaultSymbolValues: ISymbolValues = {
        "M1": {
            "5": 20,
            "6": 30,
            "7": 42,
            "8": 70,
            "9": 100,
            "10": 250,
            "11": 500,
            "12": 800,
            "13": 1000,
            "14": 1200,
            "15": 1500,
            "16": 1800,
            "17": 3600,
            "18": 5500,
            "19": 7500,
            "20": 10000,
            "21": 12500
        }, "M2": {
            "5": 14,
            "6": 18,
            "7": 25,
            "8": 40,
            "9": 60,
            "10": 125,
            "11": 250,
            "12": 350,
            "13": 500,
            "14": 750,
            "15": 1000,
            "16": 1250,
            "17": 1500,
            "18": 1800,
            "19": 3600,
            "20": 5500,
            "21": 7500
        },
        "M3": {
            "5": 13,
            "6": 17,
            "7": 22,
            "8": 35,
            "9": 55,
            "10": 100,
            "11": 150,
            "12": 300,
            "13": 400,
            "14": 600,
            "15": 800,
            "16": 1000,
            "17": 1200,
            "18": 1500,
            "19": 1800,
            "20": 3600,
            "21": 5500
        }, "M4": {
            "5": 10,
            "6": 15,
            "7": 19,
            "8": 30,
            "9": 50,
            "10": 60,
            "11": 100,
            "12": 200,
            "13": 300,
            "14": 400,
            "15": 500,
            "16": 750,
            "17": 1000,
            "18": 1200,
            "19": 1500,
            "20": 1800,
            "21": 3600
        }, "L1": {
            "5": 8,
            "6": 12,
            "7": 15,
            "8": 20,
            "9": 30,
            "10": 50,
            "11": 70,
            "12": 100,
            "13": 170,
            "14": 250,
            "15": 350,
            "16": 450,
            "17": 600,
            "18": 800,
            "19": 1000,
            "20": 1200,
            "21": 1500
        }, "L2": {
            "5": 6,
            "6": 10,
            "7": 13,
            "8": 15,
            "9": 30,
            "10": 45,
            "11": 55,
            "12": 70,
            "13": 100,
            "14": 170,
            "15": 250,
            "16": 350,
            "17": 450,
            "18": 600,
            "19": 800,
            "20": 1000,
            "21": 1200
        }, "L3": {
            "5": 5,
            "6": 8,
            "7": 10,
            "8": 15,
            "9": 18,
            "10": 40,
            "11": 45,
            "12": 80,
            "13": 100,
            "14": 150,
            "15": 200,
            "16": 250,
            "17": 350,
            "18": 450,
            "19": 600,
            "20": 800,
            "21": 1000
        }, "L4": {
            "5": 4,
            "6": 6,
            "7": 8,
            "8": 10,
            "9": 15,
            "10": 28,
            "11": 40,
            "12": 50,
            "13": 75,
            "14": 100,
            "15": 150,
            "16": 200,
            "17": 300,
            "18": 400,
            "19": 500,
            "20": 600,
            "21": 800
        }, "L5": {
            "5": 3,
            "6": 5,
            "7": 7,
            "8": 9,
            "9": 13,
            "10": 19,
            "11": 30,
            "12": 40,
            "13": 55,
            "14": 75,
            "15": 100,
            "16": 150,
            "17": 200,
            "18": 300,
            "19": 400,
            "20": 500,
            "21": 600
        }
    }

    public static isActionSpinsActive:boolean = false;
    private skinner: Skinner;

    constructor() {
        super();
        const validSkins: string[] = [
            "sweep"
        ]
        this.skinner = new Skinner(validSkins);
    }

    private handleSweepInit() {
        //Making sure that skinID is set based  on "replaceWordFree" gcc.
        if (SlotGame.apiPlugin.gameClientConfiguration.isSet) {
            if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                this.skinner.skinId = "sweep";
            }
        } else {
            SlotGame.apiPlugin.events.on(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                    this.skinner.skinId = "sweep";
                }
            })
        }
    }

    private handleSweepGetReady(): Promise<any> {
        if (this.skinner.skinId != undefined) {
            const replaceMap: Map<string, string> = new Map();
            replaceMap.set("pageImage_8", "pageImage_8.png");
            return this.skinner.loadSkin(replaceMap);
        }
        return Promise.resolve();
    }


    public static setMode(mode: string): void {
        PearlHarbor.backgroundElements.setMode(mode);
        PearlHarbor.foregroundElements.setMode(mode);
        PearlHarbor.allReelsView.setMode(mode);
        //PearlHarbor.fsView.setMode(mode);
    }


    private static addLayer(layer:any):any{
        NolimitApplication.addLayerAt(layer.name, layer, 0);
        return layer;
    }
    private static createViewsAndComponents() {

        if (NolimitConfig.isDevMode) {
            NolimitApplication.addLayerAt("SPEEDSTER", new PIXI.Container(), 0);
            PearlHarbor.addLayer(new Speedster());
        }
        //Non views
        PearlHarbor.activeSymbolsBackground = new ActiveSymbolBackground();
        PearlHarbor.allReelsView = new PearlHarborReelAreaView();

        //Static views
        // at level 16
        /*NolimitApplication.addLayerAt(PearlHarborGameConfig.LAYERS.SPEEDSTER, new PIXI.Container(), 0);
        PearlHarbor.speedster = new Speedster();*/

        // at level 15
        PearlHarbor.totalBigWinView = new PearlHarborBigWin();
        NolimitApplication.addLayerAt(PearlHarbor.totalBigWinView.name, PearlHarbor.totalBigWinView, 0);

        PearlHarbor.kamakazi = new KamakaziWinPresentation();
        NolimitApplication.addLayerAt(PearlHarbor.kamakazi.name, PearlHarbor.kamakazi, 0);
        // at level 14
        PearlHarbor.fsOutroView = new PearlHarborFSOutro();
        NolimitApplication.addLayerAt(PearlHarbor.fsOutroView.name, PearlHarbor.fsOutroView, 0);
        PearlHarbor.fsIntroView = new PearlHarborFSIntro();
        NolimitApplication.addLayerAt(PearlHarbor.fsIntroView.name, PearlHarbor.fsIntroView, 0);

        // at level 13
        PearlHarbor.winCapView = new PearlHarborWinCapView();
        NolimitApplication.addLayerAt(PearlHarbor.winCapView.name, PearlHarbor.winCapView, 0);

        // at level 10
        PearlHarbor.luckyDrawFeatureBuy = new PearlHarborLuckyDrawAnimation();
        NolimitApplication.addLayerAt(PearlHarbor.luckyDrawFeatureBuy.name, PearlHarbor.luckyDrawFeatureBuy, 0);

        // at level 8
        PearlHarbor.totalWinView = new PearlHarborTotalWinView();
        NolimitApplication.addLayerAt(PearlHarbor.totalWinView.name, PearlHarbor.totalWinView, 0);

        // at level 7
        PearlHarbor.initialWinView = new PearlHarborInitialWinView();
        NolimitApplication.addLayerAt(PearlHarbor.initialWinView.name, PearlHarbor.initialWinView, 0);

        // at level 6
        PearlHarbor.scatterAnimation = new ScatterAnimation();
        NolimitApplication.addLayerAt(PearlHarbor.scatterAnimation.name, PearlHarbor.scatterAnimation, 0);
        NolimitApplication.addLayerAt(PearlHarborGameConfig.LAYERS.XS_ANIMATION, new PIXI.Container(), 0);

        // at level 5
        PearlHarbor.hitChanceBoard = new HitChanceBoard();
        NolimitApplication.addLayerAt(PearlHarbor.hitChanceBoard.name, PearlHarbor.hitChanceBoard, 0);
        PearlHarbor.bombAttackWin = new BombAttackWinPresentation();
        PearlHarbor.dogfightWin = new DogfightWinPresentation();
        NolimitApplication.addLayerAt(PearlHarbor.bombAttackWin.name, PearlHarbor.bombAttackWin, 0);
        PearlHarbor.cocpitBoard = new CocpitBoard();
        NolimitApplication.addLayerAt(PearlHarbor.cocpitBoard.name, PearlHarbor.cocpitBoard, 0);

        // at level 4
        NolimitApplication.addLayerAt(PearlHarborGameConfig.LAYERS.MAINGAME_FRAME, new PIXI.Container(), 0);
        NolimitApplication.addLayerAt(PearlHarborGameConfig.LAYERS.ACTIVE_AREA, new PIXI.Container(), 0);

        // at level 2
        PearlHarbor.multiplier = new Multiplier();
        NolimitApplication.addLayerAt(PearlHarborGameConfig.LAYERS.MULTIPLIER, PearlHarbor.multiplier, 0);
        PearlHarbor.scatterCounter = new ScatterCounter();
        NolimitApplication.addLayerAt(PearlHarborGameConfig.LAYERS.SCATTER_COUNTER, PearlHarbor.scatterCounter, 0);
        NolimitApplication.addLayerAt(PearlHarborGameConfig.LAYERS.OVERLAY, new PIXI.Container(), 0);

        PearlHarbor.foregroundElements = new PearlHarborForeground();
        NolimitApplication.addLayerAt(PearlHarbor.foregroundElements.name, PearlHarbor.foregroundElements, 0);

        // at level 1
        //ReelView
        NolimitApplication.addLayerAt(PearlHarbor.allReelsView.name, PearlHarbor.allReelsView, 0);

        PearlHarbor.mainGameZoomContainer = new PearlHarborMainGameView();
        NolimitApplication.addLayerAt(PearlHarbor.mainGameZoomContainer.name, PearlHarbor.mainGameZoomContainer, 0);

        // at level 0
        PearlHarbor.backgroundElements = new PearlHarborBackground();
        NolimitApplication.addLayerAt(PearlHarbor.backgroundElements.name, PearlHarbor.backgroundElements, 0);

        //At level 2 with index
        //FS view
        //PearlHarbor.fsView = new PearlHarborBonusGameView();
        //NolimitApplication.addLayerAt(PearlHarbor.fsView.name, PearlHarbor.fsView, 2);

        PearlHarbor.apiPlugin.events.on(APIEvent.SELECTED_FEATURE_BET_CHANGED,(data:any)=>{
            PearlHarbor.foregroundElements.setBoostState();
        });

        PearlHarbor.apiPlugin.events.on(APIEvent.ACTION_SPINS_IS_ACTIVE,(data:any)=>{
            if (data === true){
                PearlHarbor.isActionSpinsActive = true;
              //  Disturbed.individualWin.stop();
            } else {
                PearlHarbor.isActionSpinsActive = false;
            }

            if (PearlHarbor.apiPlugin.betHandler.betBoost != undefined){
                //PearlHarbor.foregroundElements.turnOnBoost(false)
                PearlHarbor.foregroundElements.setBoostState();

            } else {
                PearlHarbor.foregroundElements.turnOffBoost(false)
            }

        });

    }

    private static getSymbolString(key: string, data: { [numSymbols: number]: number }): string {
        return `
            <div class="symbol">
            <img src="{{gamePath}}screens/images/symbols/${key}.png">
            <div class="payout-group">
                <div class="payout">
                    <span style="margin-left: 1.74em ;padding-right:0.5em" class="number">40+</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[21] * 0.05}">${data[21] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 0.85em" class="number">38-39</span>
                    <span style="margin-left: 0.1em"  class="multiplier" data-multiplier="${data[20] * 0.05}">${data[20] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 0.85em" class="number">34-37</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[19] * 0.05}">${data[19] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 0.75em ;padding-right:0.6em" class="number">30-33</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[18] * 0.05}">${data[18] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 0.75em ;padding-right:0.6em" class="number">25-29</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[17] * 0.05}">${data[17] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 0.75em ;padding-right:0.6em" class="number">22-24</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[16] * 0.05}">${data[16] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 0.75em ;padding-right:0.6em" class="number">19-21</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[15] * 0.05}">${data[15] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 0.75em ;padding-right:0.6em" class="number">17-18</span>
                    <span style="margin-left: 0.1em"  class="multiplier" data-multiplier="${data[14] * 0.05}">${data[14] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 0.75em ;padding-right:0.6em" class="number">15-16</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[13] * 0.05}">${data[13] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 0.75em ;padding-right:0.6em" class="number">13-14</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[12] * 0.05}">${data[12] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 0.85em;padding-right:0.5em" class="number">11-12</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[11] * 0.05}">${data[11] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 2.23em;padding-right:0.6em" class="number">10</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[10] * 0.05}">${data[10] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 2.38em ;padding-right:1em" class="number">9</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[9] * 0.05}">${data[9] * 0.05}</span>
                </div>
                <div class="payout">
                    <span  style="margin-left: 2.38em ;padding-right:1em" class="number">8</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[8] * 0.05}">${data[8] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 2.38em ;padding-right:1em" class="number">7</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[7] * 0.05}">${data[7] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 2.38em ;padding-right:1em" class="number">6</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[6] * 0.05}">${data[6] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 2.38em ;padding-right:1em" class="number">5</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[5] * 0.05}">${data[5] * 0.05}</span>
                </div>
            </div>
            </div>
        `;
    }

    getNoWinGameData(): any {
        return {
            "reels": [["M4", "M3", "M4", "M4", "M3", "L5", "L1"], ["L2", "M1", "M3", "L4", "M1", "L2", "M1"], ["M4", "L2", "M2", "M2", "M4", "M3", "L2"], ["M3", "M3", "L1", "M3", "BN", "L3", "M3"], ["L3", "L5", "M2", "L3", "M2", "L1", "M3"], ["L5", "M1", "X_BOMB", "L4", "M1", "L5", "M1"], ["M1", "L1", "M1", "L1", "M4", "L3", "M4"]],
            "evaluatedArea": [["X", "X", "X", "X", "X", "X", "X"], ["X", "X", "X", "X", "X", "X", "X"], ["X", "X", "M2", "M2", "M4", "X", "X"], ["X", "X", "L1", "M3", "BN", "X", "X"], ["X", "X", "M2", "L3", "M2", "X", "X"], ["X", "X", "X", "X", "X", "X", "X"], ["X", "X", "X", "X", "X", "X", "X"]],
            "betClusterWins": [],
            "thisSpinWinnings": 0.0,
            "accumulatedRoundWin": 0.0,
            "playedBetValue": 1.0,
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "freespinTriggeredThisSpin": false,
            "numberOfFreespinsPlayed": 0.0,
            "freespinsLeft": 0.0,
            "scatterPositionsEnteringFreespin": [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
            "scatterPositions": [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
            "allWinPositions": [[false, false, false, false, false, false, false], [false, false, false, false, false, false, false], [false, false, false, false, false, false, false], [false, false, false, false, false, false, false], [false, false, false, false, false, false, false], [false, false, false, false, false, false, false], [false, false, false, false, false, false, false]],
            "explodePositions": [[false, false, false, false, false, false, false], [false, false, false, false, false, false, false], [false, false, false, false, false, false, false], [false, false, false, false, false, false, false], [false, false, false, false, false, false, false], [false, false, false, false, false, false, false], [false, false, false, false, false, false, false]],
            "allSizesBeforeCollapse": [[1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0], [1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0], [1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0], [1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0], [1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0], [1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0], [1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0]],
            "numberOfScatters": 1.0,
            "totalSpinRoundWinnings": 0.0,
            "wasFeatureBuy": false,
            "enhancedBet": 0.0,
            "brokeBank": false,
            "currentMultiplier": 1.0,
            "multiplierNextSpin": 1.0,
            "allSizesAfterLastCollapse": [[0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0], [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0], [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0], [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0], [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0], [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0], [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0]],
            "xSplits": {},
            "xSplitsWhenLanding": {},
            "xsplitsTriggeredThisTurn": {},
            "xsplitsMultipliers": {},
            "xsplitsMultipliersWhenLanding": {},
            "bigSymPresent": false,
            "listOfBigSymsDestroyedOrMovedThisSpin": [],
            "centerPoint2Delete": 48.0,
            "barriers2Delete": [-2.0, 3.0, -14.0, 14.0],
            "bigSymsResponse": {
                "symbolsLanding": [],
                "symbolsAfterSplit": [],
                "symbolsCollapse": [],
                "topLeftSeedLanding": [],
                "topLeftSeedAfterSplit": [],
                "topLeftSeedCollapse": [],
                "sizeReelLanding": [],
                "sizeReelAfterSplit": [],
                "sizeReelCollapse": [],
                "sizeRowLanding": [],
                "sizeRowAfterSplit": [],
                "sizeRowCollapse": [],
                "multLanding": [],
                "multAfterSplit": [],
                "multCollapse": []
            }
        };
    }

    public init(): Promise<NolimitPlugin> {

        return super.init().then((value: NolimitPlugin) => {

            PearlHarbor.model = new PearlHarborModel(SlotGame.apiPlugin, true);
            PearlHarbor.gameFlowController = new GameFlowController(SlotGame.apiPlugin, PearlHarbor.model);
            PearlHarbor.gameFlowController.flowStateLogger.level = LogLevel.DEV;
            //new ActionSpinHandler();
            const winPres: PearlHarborWinPresentation = new PearlHarborWinPresentation();
            const idleNormal: PearlHarborIdleNormalPresentation = new PearlHarborIdleNormalPresentation();
            const reelStart: PearlHarborNormalBetPresentation = new PearlHarborNormalBetPresentation();
            const fsReelStart: PearlHarborFSBetPresentation = new PearlHarborFSBetPresentation();
            const fsResult: PearlHarborFSResultPresentation = new PearlHarborFSResultPresentation();
            const normalResult: PearlHarborNormalResultPresentation = new PearlHarborNormalResultPresentation();
            const fsWinPres: PearlHarborFSWinPresentation = new PearlHarborFSWinPresentation();
            const zeroBetIdle: PearlHarborZeroBetIdlePresentation = new PearlHarborZeroBetIdlePresentation();

            const avalancheIdle: PearlHarborIdlePresentation = new PearlHarborIdlePresentation();
            const avalancheStart: PearlHarborBetPresentation = new PearlHarborBetPresentation();
            const avalancheFillUpReels: PearlHarborFillUpReelsPresentation = new PearlHarborFillUpReelsPresentation();

            PearlHarbor.gameFlowController.addGameModeFlowStatePresentationMap(PearlHarborGameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, idleNormal],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winPres]
            ]));

            PearlHarbor.gameFlowController.addGameModeFlowStatePresentationMap(PearlHarborGameMode.NORMAL_AVALANCHE, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, avalancheIdle],
                [FlowState.BET, avalancheStart],
                [FlowState.RESULT, avalancheFillUpReels],
                [FlowState.WIN, winPres]
            ]));

            PearlHarbor.gameFlowController.addGameModeFlowStatePresentationMap(PearlHarborGameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBetIdle],
                [FlowState.BET, fsReelStart],
                [FlowState.RESULT, fsResult],
                [FlowState.WIN, fsWinPres]
            ]));

            PearlHarbor.gameFlowController.addGameModeFlowStatePresentationMap(PearlHarborGameMode.FREESPIN_AVALANCHE, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBetIdle],
                [FlowState.BET, fsReelStart],
                [FlowState.RESULT, fsResult],
                [FlowState.WIN, fsWinPres]
            ]));

            PearlHarbor.gameFlowController.addGameModeFlowStatePresentationMap(PearlHarborGameMode.SUPER_FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBetIdle],
                [FlowState.BET, fsReelStart],
                [FlowState.RESULT, fsResult],
                [FlowState.WIN, fsWinPres]
            ]));

            PearlHarbor.gameFlowController.addGameModeFlowStatePresentationMap(PearlHarborGameMode.SUPER_FREESPIN_AVALANCHE, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBetIdle],
                [FlowState.BET, fsReelStart],
                [FlowState.RESULT, fsResult],
                [FlowState.WIN, fsWinPres]
            ]));

            this.handleSweepInit();
            return value;
        });
    }

    public getReady(): Promise<NolimitPlugin> {

        //Show intro and load game assets
        return super.getReady().then((value: NolimitPlugin) => {

            const fontLoader = new FontLoader(NolimitApplication.resourcePath);
            fontLoader.add(OpenSans.ITALIC_600);
            fontLoader.add(OpenSans.NORMAL_300);
            fontLoader.add(OpenSans.NORMAL_400);
            fontLoader.add(OpenSans.NORMAL_700);

            AssetsConfig.addToAssetsConfig(PearlHarborGameAssets.RESOURCES_GROUPS);
            PearlHarbor.assetLoader = new AssetLoader(PearlHarbor.apiPlugin, NolimitApplication.resourcePath + "/resources/");

            const promises = Promise.all([fontLoader.load(), PearlHarbor.assetLoader.load(ResourcesGroupName.MAIN), this.handleSweepGetReady()]);

            return promises.then(() => {
                PearlHarbor.createViewsAndComponents();

                if (PearlHarbor.apiPlugin.isReplay) {
                    if (PearlHarbor.model.data.nextPlayerInteraction?.featureName === "BOOSTED_BET") {
                        PearlHarbor.foregroundElements.showBoostButtonOnRestore(PearlHarborToggleState.ON1);
                    }
                    if (PearlHarbor.model.data.nextPlayerInteraction?.featureName === "BOOSTED_BET_2") {
                        PearlHarbor.foregroundElements.showBoostButtonOnRestore(PearlHarborToggleState.ON2);
                    }
                } else if (PearlHarbor.apiPlugin.freeBets.hasFreeBets()) {
                    PearlHarbor.foregroundElements.turnOffBoost(true);
                } else if (PearlHarbor.model.isRestore) {
                    if (PearlHarbor.model.data.enhancedBet > 0) {
                        const state: PearlHarborToggleState = (PearlHarbor.model.data.enhancedBet > 1 ? PearlHarborToggleState.ON2 : PearlHarborToggleState.ON1);
                        PearlHarbor.foregroundElements.showBoostButtonOnRestore(state);
                    }

                }

                PearlHarbor.promoPanelOpened = false;
                PearlHarbor.apiPlugin.events.on(PromoPanelEvents.PROMO_PANEL_OPENED, ()=>{
                    PearlHarbor.promoPanelOpened = true;
                });
                PearlHarbor.apiPlugin.events.on(PromoPanelEvents.PROMO_PANEL_CLOSED, ()=>{
                    PearlHarbor.promoPanelOpened = false;
                });
                PearlHarbor.apiPlugin.events.on(PromoPanelEvents.PROMO_PANEL_MINIMIZED, ()=>{
                    PearlHarbor.promoPanelOpened = false;
                });
                PearlHarbor.apiPlugin.events.on(PromoPanelEvents.PROMO_PANEL_MAXIMIZED, ()=>{
                    PearlHarbor.promoPanelOpened = true;
                });
                return value;
            });
        });
    }

    public getReadyToStart(): Promise<NolimitPlugin> {

        //Game assets loaded, waiting for user to start game.
        PearlHarborSoundManager.playAmbientLoop();
        return super.getReadyToStart().then((value: NolimitPlugin) => {

            if (PearlHarbor.model.isRestore) {
                PearlHarbor.keypadPlugin.setWin(PearlHarbor.model.initData.accumulatedRoundWin, true, PearlHarborHelper.isWinBelowStake());

                if (PearlHarborHelper.isFreeSpin(PearlHarbor.model.data.mode)) {
                    PearlHarbor.enteringInFs = true;
                }
            }
            PearlHarbor.activeSymbolsBackground.onGameReady();
            PearlHarbor.setMode(PearlHarbor.model.data.mode);
            return value;
        });
    }

    public start(): Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.
        PearlHarborHelper.isGameStarted = true;
        PearlHarborSoundManager.playContinueBtnSound();

        if (PearlHarbor.model.data.isRestoreState && PearlHarborHelper.isFreeSpin(PearlHarbor.model.data.mode)) {
            PearlHarborSoundManager.playAmbientLoop();
            //#405
            //PearlHarbor.backgroundElements.fsSpinsBoard.updateSpinLeftCount((PearlHarbor.model.data.fsObject.freespinsLeft - PearlHarbor.model.data.fsObject.freespinsAddedThisSpin) - 1);
        }

        if (PearlHarbor.model.data.isRestoreState && PearlHarborHelper.isFreeSpin(PearlHarbor.model.data.nextMode)) {
            PearlHarborSoundManager.playAmbientLoop();
        }

        if (PearlHarbor.model.data.isRestoreState && !PearlHarborHelper.isFreeSpin(PearlHarbor.model.data.mode)) {
            PearlHarbor.multiplier.value = PearlHarbor.model.initData.currentMultiplier;
            if (PearlHarbor.multiplier.value > 1) {
                PearlHarbor.multiplier.show();
            }
        }
        return super.start().then((value: NolimitPlugin) => {
            PearlHarbor.gameFlowController.start();
            return value;
        });

    }

    private paytable: string = require("../../nolimit/screens/paytable.mustache");
    public getPaytable(): Promise<string> {
        return new Promise((resolve, reject) => {
            const data = {
                skinPath: "screens/images/"
            };
            if (this.skinner.skinId != undefined) {
                data.skinPath = `../resources/images/${this.skinner.skinId}/`;
            }
            let symbolDataValueData: ISymbolValues = this._defaultSymbolValues;
            if (PearlHarbor.model.initData.symbolValues) {
                symbolDataValueData = PearlHarbor.model.initData.symbolValues;
                Logger.logDev("Using symbolValues from INIT data");
            } else {
                Logger.logDev("Using default symbolValues");
            }
            let paytableString: string = (<any>this.paytable).text;
            paytableString = paytableString.replace(/{{skinPath}}/g, data.skinPath);
            for (let key in symbolDataValueData) {
                paytableString = paytableString.replace(`{{${key}}}`, PearlHarbor.getSymbolString(key, symbolDataValueData[key]));
            }
            resolve(paytableString);
        });
    }
}